import {CardPaymentsRetryPolicy, Weekday} from "../../../apis/requests/payment-flows/types";
import {COMBINE_MODE_SUMMARY} from "./retry-test-form/constants";

export const formatWeekday = (weekday: Weekday): string => weekday.charAt(0).toUpperCase() + weekday.slice(1);

export const getPolicySummary = (policy: CardPaymentsRetryPolicy): string[] => {
  const summary = [`max ${policy.max_day} days`, COMBINE_MODE_SUMMARY[policy.combine]];
  if (policy.peak_day.length > 0 && policy.peak_day_hours.length > 0) {
    summary.push(`peak at ${policy.peak_day_hours.join(", ")}`);
  }
  if (policy.skip_weekdays.length > 0) {
    summary.push(`skips ${policy.skip_weekdays.map(formatWeekday).join(", ")}`);
  }
  return summary;
};
